import React,{useEffect} from "react";
import css from "./HomeScreen.module.css";
import {AppIcon,BubblingView,FooterView,HeaderView} from "Components";
import {fadeIn} from "vritra";


export default function HomeScreen(props){
    const {}=props;
    useEffect(()=>{
        const contentEl=document.querySelector(`.${css.content}`);
        fadeIn(contentEl,1500,()=>{
            contentEl.style.opacity=1;
        });
    },[]);
    return (
        <div className={css.homescreen}>
            <HeaderView 
                className={css.header}
                showLibs="all" 
                searchBarShown={window.innerWidth>567}
            />
            <main className={css.content}>
                <AppIcon clickable={false} style={{fontSize:"4em"}}/>
                <p className={css.description}>{language.$appdescription}</p>
                <button 
                    className={css.startbtn}
                    onClick={()=>{location.hash="getstarted"}}
                >{language.getstarted}</button>
                <BubblingView/>
            </main>
            <FooterView className={css.footer}/>
        </div>
    )
}
